import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { CoberturaResumen, EstimacionResumen } from 'src/app/models/complementos-web/complementos-web.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { TitleCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-tooltip-detalle-cobertura-resumen',
    templateUrl: './tooltip-detalle-cobertura-resumen.component.html',
    styleUrls: ['./tooltip-detalle-cobertura-resumen.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCardContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, MatCardActions, MatButton, TitleCasePipe]
})
export class TooltipDetalleCoberturaResumenComponent {

  columnas: string[] = [];
  columnasTotales: string[] = ['bienes', 'lesiones', 'rc_catastrofico', 'catastrofico']; // columnas a totalizar

  datosCoberturas = new MatTableDataSource([]);

  constructor(
    public dialogRef: MatDialogRef<TooltipDetalleCoberturaResumenComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: {
      cobertura: CoberturaResumen, detalleCoberturasResumen: EstimacionResumen
    },
  ) {
    console.log(this.data)
    this.construirTablaDetalle();
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  construirTablaDetalle() {
    this.columnas.push('id_tercero');

    if (this.data.cobertura.cve_coberturak == 3) {
      if (this.data.detalleCoberturasResumen.totales.bienes != "0.00") {
        this.columnas.push('bienes');
      }
      if (this.data.detalleCoberturasResumen.totales.lesiones != "0.00") {
        this.columnas.push('lesiones');
      }
      if (this.data.detalleCoberturasResumen.totales.rc_catastrofico != "0.00") {
        this.columnas.push('rc_catastrofico');
      }
    }

    if (this.data.cobertura.cve_coberturak == 96) {
      if (this.data.detalleCoberturasResumen.totales.catastrofico != "0.00") {
        this.columnas.push('catastrofico');
      }
    }

    this.datosCoberturas = new MatTableDataSource(this.data.detalleCoberturasResumen.detalle)
  }

  procesarTotal(columna: string) {
    return columna == 'id_tercero' ? 'Total' : this.data.detalleCoberturasResumen.totales[columna];
  }

}
